<template>
  <div id="authenticate" class="row no-gutters">
    <div class="col-12 no-gutters auth-col">
      <div class="row no-gutters">
        <div class="col-xl-6 col-10 offset-xl-3 offset-1 forms login-col">
          <login />
        </div>
        <div class="col-xl-6 col-10 offset-xl-3 offset-1 d-flex justify-content-center">
          <div class="mt-3">
            <router-link :to="{name: 'RegistrationScreen'}">{{$t('login.registrationLinkText')}}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/shared/elements/BaseButton';
import SignUpModal from '@/components/shared/modals/SignUpModal';
import Login from './Login';

export default {
  name: 'Authenticate',
  components: {
    Login,
    BaseButton,
  },
  methods: {
    goToRegistration() {
      this.$eventBus.showModal({
        bind: {
          is: SignUpModal,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#authenticate {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

